export const env = {
  development: {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
  },
};
